import { FC } from "react";
import { AdminOrganizationResDto } from "service/api/estabrookSchemas";
import WarningConfirmDialog from "./WarningConfirmDialog";

export interface OrganizationAccessConfirmDialogProps {
  organization: AdminOrganizationResDto | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const OrganizationAccessConfirmDialog: FC<
  OrganizationAccessConfirmDialogProps
> = ({ organization, isSubmitting, onConfirm, onCancel }) => {
  const isDeactivating = organization ? organization.isActive : false;
  const actionLabel = isDeactivating ? "Remove Access" : "Restore Access";

  return (
    <WarningConfirmDialog
      open={Boolean(organization)}
      title={actionLabel}
      description={`Are you sure you want to ${
        isDeactivating ? "remove" : "restore"
      } access for ${organization?.name}?`}
      warningText={
        isDeactivating
          ? "All team members will be logged out and lose access to the platform."
          : undefined
      }
      confirmLabel={actionLabel}
      isSubmitting={isSubmitting}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmTestId="confirm-access-toggle"
      cancelTestId="cancel-access-toggle"
    />
  );
};

export default OrganizationAccessConfirmDialog;
